import React from 'react';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: React.ReactNode;
  description?: string;
  size?: 'sm' | 'md';
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, description, size = 'md', className = '', id, disabled, ...props }, ref) => {
    const generatedId = React.useId();
    const inputId = id || generatedId;

    const sizeStyles = {
      sm: 'w-3.5 h-3.5',
      md: 'w-4 h-4',
    };

    return (
      <div className={`flex items-start gap-2 select-none ${className}`}>
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            id={inputId}
            ref={ref}
            disabled={disabled}
            className={`${sizeStyles[size]} rounded border-cf-border bg-cf-input text-cf-orange focus:ring-cf-orange/50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer transition-colors`}
            {...props}
          />
        </div>
        {(label || description) && (
          <div className="text-xs">
            {label && (
              <label
                htmlFor={inputId}
                className={`font-medium text-cf-textPrimary cursor-pointer ${
                  disabled ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {label}
              </label>
            )}
            {description && (
              <p className="text-[11px] text-cf-textMuted mt-0.5">{description}</p>
            )}
          </div>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
